"use client";
import React from "react";
import Footer from "./Footer";
import Provider from "./Provider";

import Header from "./Header";
import SmoothScrollWrapper from "@/components/SmoothScroll";

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider>
      <div className="sticky top-0 w-full z-50">
        <Header />
      </div>
      <SmoothScrollWrapper>
        {children}
        <Footer />
      </SmoothScrollWrapper>
    </Provider>
  );
};

export default Layout;
